/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Message center client-side code

namespace('Slzr.Page.Messages', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const MESSAGE_CENTER_CONVERSATION_URL = "/messagecenter/@ID@";

  return Slzr.jQuery(function($) {
    if (Slzr.Meta.page !== 'messages') { return; }

    const conversation_container = $('[data-conversation="content"]');
    const conversation_list = $('[data-conversation="conversations"]');
    const loading = $('[data-conversation="loading"]');

    const showLoading = function() {
      loading.show();
      return conversation_container.hide();
    };

    const hideLoading = function() {
      loading.hide();
      return conversation_container.show();
    };

    // Update the HTML based on a response
    const updateHTML = function(result) {
      if (result.conversation_list != null) { conversation_list.html(result.conversation_list); }
      if (result.messages != null) { return conversation_container.html(result.messages); }
    };

    // Refresh both a selected conversation and the conversation list
    const refreshConversations = function(selected = null) {
      const conversation_url = MESSAGE_CENTER_CONVERSATION_URL.replace('@ID@', selected);

      showLoading();

      // If a group message is sent, display a sent notice and no conversation.
      if (selected.match(/^group_/)) {
        flashNotice("Message sent");
        return selectConversation('none');
      }  // show user to user conversation like normal.
        return $.get(conversation_url, function(result) {
          updateHTML(result);
          hideLoading();

          conversation_list.find('.active_entry').removeClass('active_entry');
          return conversation_list.find(`[data-with-id="${  selected  }"]`).addClass('active_entry');
        });
      
    };

    // Select/refresh the messages for a conversation
    var selectConversation = function(with_id) {
      const conversation_url = MESSAGE_CENTER_CONVERSATION_URL.replace('@ID@', with_id);

      showLoading();
      return $.get(conversation_url, function(result) {
        updateHTML(result);
        hideLoading();

        conversation_list.find('.active_entry').removeClass('active_entry');
        return conversation_list.find(`[data-with-id="${  with_id  }"]`).addClass('active_entry');
      });
    };

    // Load a new conversation into the conversation viewer
    $(document).onAction('select-conversation', function(evt) {
      const with_id = $(this).data('with-id');
      selectConversation(with_id);
      return evt.preventDefault();
    });

    // Load previous page of messages
    $(document).onAction('load-previous', function(evt) {
      const page_url = $(this).attr('href');
      $.get(page_url, updateHTML);
      return evt.preventDefault();
    });

    $(document).onAction('compose-message', function(evt) {
      const conversation_url = MESSAGE_CENTER_CONVERSATION_URL.replace('@ID@', 'new');

      // Get the HTML for a new message
      showLoading();
      return $.get(conversation_url, function(result) {
        updateHTML(result);
        return hideLoading();
      });
    });

    // Delete all messages from a conversation
    $(document).onAction('remove-conversation', function(evt) {
      evt.stopPropagation();
      const conversation_delete_url = $(this).attr('href');
      const conversation_element = $(this).closest('[data-conversation="conversation"]');

      return $.ajax({
        url: conversation_delete_url,
        type: 'DELETE'}).fail(function(jqxhr, textStatus, errorThrown) {
        if (typeof console !== 'undefined' && console !== null) {
          console.error('error removing conversation:', errorThrown.stack);
        }
        return flashNotice('There was a problem removing the conversation. Please try again'); }).done(function(result) {
        conversation_element.remove();
        selectConversation('none');
        return hideNotice();
      });
    });

    $(document).onAction('cancel-compose', function(evt) {
      selectConversation('none');
      return evt.stopPropagation();
    });

    return $(document).on('submit', 'form[data-form="compose-message"]', function(evt) {
      const $form = $(this);
      const url = $form.attr('action');
      const post_data = $form.serializeArray();

      // validate form
      const message = $form.find('[name="message"]').val();
      const with_id = $form.find('[name="send_to"]').val();

      let ok = true;
      if (with_id.isBlank()) {
        alert("I don't know where to send the message!");
        ok = false;
      } else if (message.isBlank()) {
        alert("You must specify a message to send!");
        ok = false;
      }

      evt.preventDefault();
      if (!ok) { return false; }

      // Post!
      const submit_button = $form.find('input[type="submit"]');
      submit_button.data('old-value', submit_button.val()).val('Sending...').prop('disabled', true).addClass('disabled');

      $.ajax({
        url,
        type: 'POST',
        data: {
          send_to: with_id,
          message
        }}).fail(function(jqxhr, textStatus, errorThrown) {
        if (typeof console !== 'undefined' && console !== null) {
          console.error('error sending message:', errorThrown.stack);
        }
        flashNotice('There was a problem sending the message. Please try again');
        return submit_button.val(submit_button.data('old-value')).prop('disabled', false).removeClass('disabled'); }).done(function(result) {
        if (result.ok) {
          hideNotice();
          // Refresh conversation and message list
          return refreshConversations(with_id);
        } 
          // Do something useful
          if (result.error === 'no_message') {
            flashNotice('You must provide a message to send');
          } else if (result.error === 'no_target') {
            flashNotice("I don't know where to send the message");
          } else {
            flashNotice('There was a problem sending the message. Please try again');
          }

          return submit_button.val(submit_button.data('old-value')).prop('disabled', false).removeClass('disabled');
        
      });

      evt.preventDefault();
      return false;
    });
  });
});
